<template>
  <section>
    <button @click="toggleOn" class="button" :class="props.type">
      <span v-if="props.icon" class="icon"
        ><Icon :icon="props.icon"></Icon
      ></span>
      <span>{{ props.label }}</span></button
    ><b-modal :active.sync="isModalActive" v-bind="props.modalSetting">
      <slot></slot>
    </b-modal>
  </section>
</template>

<script>
import { ref } from "@vue/composition-api";
import Icon from "./Icon";

export default {
  props: {
    label: String,
    icon: String,
    modalSetting: Object,
    type: String
  },
  components: { Icon },
  setup(props) {
    const isModalActive = ref(false);
    const toggleOn = () => {
      isModalActive.value = true;
    };
    return {
      isModalActive,
      toggleOn,
      props
    };
  }
};
</script>
